import modalMixin from '../../mixins/_modal';

/**
 * ストアカテゴリリセット確認モーダル
 */
export default {
    name: 'modal-store-category-reset',
    template: '#modal_store_category_reset_template',
    props: {
        // 選択されたパスリスト
        path_config: {
            type: Array,
            default: () => ([])
        },
        step: {
            type: Number
        },
    },
    mixins: [modalMixin],
    watch: {
        path_config: function (newValues/*, oldValue */) {
            // stepが商品編集画面、かつ、path_config（ストアカテゴリ）が０件の場合、モーダル表示
            if (this.step === 3 && newValues.length === 0) {
                this.open();
            }
        },
    }
};
